import React, { useState } from "react";

import EnvironmentBackupModal from "Containers/NavBar/Environment/BackupModal";
import Loading from "ds/PageLoading";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { backupsStoreSelector } from "Reducers/backupsStored/backupsStoredReducer.selectors";
import { getAllBackups } from "Reducers/backupsStored/thunks/getAllBackups.thunk";
import { environmentSelector } from "Reducers/environment";
import BackupsList from "src/organization/common/components/BackupsList/index";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import { NoBackupsIllustration } from "./Backups";
import * as S from "./Backups.styles";

export interface BackupsStoredProps {
  environmentId: string;
  projectId: string;
  organizationId: string;
}
const BackupsStored = ({
  projectId,
  environmentId,
  organizationId
}: BackupsStoredProps) => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const { isLoading, backupsManual, backupsAutomated } =
    useAppSelector(backupsStoreSelector);

  const dispatch = useAppDispatch();

  const environment = useSelectorWithUrlParams(environmentSelector);

  let element: React.ReactNode = undefined;

  if (isLoading) {
    element = <Loading />;
  } else if (!backupsManual?.length && !backupsAutomated?.length) {
    element = <NoBackupsIllustration onClick={() => setOpenModal(true)} />;
  } else {
    element = (
      <S.List>
        {backupsManual?.length ? (
          <BackupsList
            data-testid="BackupsStored_manual"
            backups={backupsManual}
            category="Manual"
            quantity={backupsManual?.length}
            parent={environment?.parent || ""}
            name={environment?.name || ""}
            projectId={projectId}
            environmentId={environmentId}
            organizationId={organizationId}
            getAllBackups={() =>
              dispatch(getAllBackups({ projectId, environmentId }))
            }
          />
        ) : null}
        {backupsAutomated?.length ? (
          <BackupsList
            data-testid="BackupsStored_automated"
            backups={backupsAutomated}
            category="Automated"
            quantity={backupsAutomated?.length}
            parent={environment?.parent || ""}
            name={environment?.name || ""}
            projectId={projectId}
            environmentId={environmentId}
            organizationId={organizationId}
            getAllBackups={() =>
              dispatch(getAllBackups({ projectId, environmentId }))
            }
          />
        ) : null}
      </S.List>
    );
  }

  return (
    <>
      {element}
      <EnvironmentBackupModal
        isOpen={openModal}
        closeModal={() => setOpenModal(false)}
      />
    </>
  );
};

export default BackupsStored;
